import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import styles from "./editprofile.module.css";
import Myprofile from '../myprofile/Myprofile';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { updateProfileThunk } from '../../../redux/userSlice';
import api from '../../../helper/Api';
import Toastify from '../../../helper/Toastify';
import OtpPopup from '../../../Website/components/otp/OtpPopUp';

const Editprofile = () => {
    const { user } = useSelector((state) => state.user);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false)
    console.log('user',user);
    const [showModal, setShowModal] = useState(false)
    const [data, setData] = useState(null)

    // Formik Setup
    const { values, errors, touched, handleChange, handleBlur, handleSubmit, resetForm, setValues } = useFormik({
        initialValues: {
            firstName: user?.firstName || "",
            lastName: user?.lastName || "",
            email: user?.email || "",
            phone: user?.phone || ""
        },
        validationSchema: Yup.object({
            firstName: Yup.string().required("First Name is required"),
            lastName: Yup.string().required("Last Name is required"),
            email: Yup.string().email("Invalid email").required("Email is required"),
            phone: Yup.string().required("Phone number is required"),
        }),
        onSubmit: async (values) => {
            setLoading(true);
        
            // Determine what changed (email or phone)
            const updatedFields = {};
            if (values.email !== user.email) {
                updatedFields.email = values.email;
            }
            if (values.phone !== user.phone) {
                updatedFields.phone = values.phone;
            }
        
            // If neither changed, just update the profile without OTP
            if (!updatedFields.email && !updatedFields.phone) {
                const status = await dispatch(updateProfileThunk(values));
                setLoading(false);
                if (status.payload === 200) {
                    // Toastify.success("Profile updated successfuly");
                    navigate("/myprofile");
                }
                return;
            }
        
            // Proceed with OTP verification flow
            const status = await dispatch(updateProfileThunk(values));
            setLoading(false);
            if (status.payload === 200) {
                setShowModal(true);
                setData(updatedFields); // pass only email or phone (whichever changed)
            }
        }
        
    });
console.log('values==========',values);

    useEffect(() => {
        if (user) {
            setValues({
                firstName: user.firstName || "",
                lastName: user.lastName || "",
                email: user.email || "",
                phone: user.phone || ""
            });
        }
    }, [user,setValues]);

    const cancelHandler = () => {
        resetForm();
        navigate("/myprofile");
    }

    // const updatedProfile = {
    //     firstName: user.firstName,
    //     lastName: user.lastName,
    //     email: user.email,
    //     phone: user.phone
    // };


    // const handleOtpSubmit = async (otp) => {


    //     console.log(updatedProfile);

    //     setLoading(true);

    //     try {
    //         const response = await api.updateProfile(updatedProfile);
    //         if (response?.data.data.message === 'Update Successfull') {
    //             Toastify.success(response.data.data.message);
    //             navigate("/My Profile")
    //         }
    //         else {
    //             setShowModal(true)
    //         }
    //     } catch (err) {
    //         console.error("Error updating profile:", err?.message);
    //         // toast.error(err?.response?.data?.message || "Something went wrong");
    //     } finally {
    //         // Set loading to false once the API call finishes (either success or error)
    //         setLoading(false);
    //     }
    // };


    return (
        <Myprofile>
            <div className={styles.profilebodyContainer}>
                <div className={styles.profileheader}>
                    <h2>Edit Profile</h2>
                </div>
                <div className={styles.profilebodyContent}>
                    <form onSubmit={handleSubmit} className={styles.profilebodyDetails}>
                        <label htmlFor="firstName">First Name</label>
                        <input
                            type="text"
                            id="firstName"
                            name="firstName"
                            value={values.firstName || ''}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            placeholder='Enter'
                        />
                        {touched.firstName && errors.firstName && <span className={styles.error}>{errors.firstName}</span>}

                        <label htmlFor="lastName">Last Name</label>
                        <input
                            type="text"
                            id="lastName"
                            name="lastName"
                            value={values.lastName || ''}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            placeholder='Enter'
                        />
                        {touched.lastName && errors.lastName && <span className={styles.error}>{errors.lastName}</span>}

                        <label htmlFor="email">Email</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            value={values.email || ''}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            placeholder='Enter'
                        />
                        {touched.email && errors.email && <span className={styles.error}>{errors.email}</span>}

                        <label htmlFor="phone">Phone Number</label>
                        <input
                            type="tel"
                            id="phone"
                            name="phone"
                            value={values.phone || ''}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            placeholder='Enter'
                        />
                        {touched.phone && errors.phone && <span className={styles.error}>{errors.phone}</span>}

                        <div className={styles.formBtnsCont}>
                            <button type="button" className={styles.cancel} onClick={cancelHandler}>Cancel</button>
                            <button type="submit" className={styles.savechanges} disabled={loading}>{loading ? "please wait..." : "Save Changes"}</button>
                        </div>
                    </form>
                </div>
            </div>
            <OtpPopup
                open={showModal}
                onClose={() => setShowModal(false)}
                // handleOtpSubmit={handleOtpSubmit}
                profileData={data}
                loading={false}
                error={null}
                success={false}
            />
        </Myprofile>
    );
};

export default Editprofile;
